import { INCIDENT_REPORT_USER_TYPES } from './types';

export default Object.freeze({
  fields: [],
  builderFields: {
    creator: {
      active: [],
      deleted: [],
    },
    reviewer: {
      active: [],
      deleted: [],
    },
  },
  fieldResults: {},
  config: {
    userType: INCIDENT_REPORT_USER_TYPES.CREATOR,
  },
});
